import { render } from "./tip-concent-msg-box.vue?vue&type=template&id=a71944a8&scoped=true&ts=true"
import script from "./tip-concent-msg-box.vue?vue&type=script&lang=ts"
export * from "./tip-concent-msg-box.vue?vue&type=script&lang=ts"

import "./tip-concent-msg-box.vue?vue&type=style&index=0&id=a71944a8&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a71944a8"]])

export default __exports__